import MainAddress from "../..";
import axios from 'axios';
import { GetSerialProgram } from "../../../util/sessionManager";

export async function getAllMarketers(){
    try{
        
        
        const response = await axios.post(
            MainAddress+'GPS/ReadVisitorList.php',
            {
                codeprogram: GetSerialProgram()
            }
          )
    
        if(response.data[0].success){
            console.log(response);
            console.log(response.data);
            return {success:true,data:[...response.data]};
        }else{
            let message;
            response.data.map(i=>{
                message+=i[0];
            })
            console.log(response);
            console.log(response.data);
            console.log(message);
            return {
                success:false,
                message:message
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }
}

export async function getMarketerLoaction(data){
    try{
        
        
        const response = await axios.post(
            MainAddress+'GPS/location_visitor.php',
            {
                codeprogram: GetSerialProgram(),
                ...data
            }
          )
    
        if(response.data[0].success){
            console.log(response);
            console.log(response.data);
            return {success:true,data:[...response.data]};
        }else{
            let message;
            response.data.map(i=>{
                message+=i[0];
            })
            console.log(response);
            console.log(response.data);
            console.log(message);
            return {
                success:false,
                message:message
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }
}